export function isCanadianPostalCode(str: string): { isCanadian: boolean; normalizedValue: string } {
  const stripped = str.substring(0, 3).toUpperCase();
  const isCanadian = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]$/i.test(stripped);
  return { isCanadian, normalizedValue: isCanadian ? stripped : str };
}
